import { useAtom } from "jotai";
import {
  subscriptionTierAtom,
  subscriptionEndAtom,
  isDemoAtom,
  emailAtom,
  preferencesAtom,
  completedTasksAtom,
  referralCodeAtom,
  showIntroFlagAtom,
} from "../../store/atoms/userAtoms.js";

// User State Hook
export const useUser = () => {
  const [subscriptionTier, setSubscriptionTier] = useAtom(subscriptionTierAtom);
  const [subscriptionEnd, setSubscriptionEnd] = useAtom(subscriptionEndAtom);
  const [isDemo, setIsDemo] = useAtom(isDemoAtom);
  const [email, setEmail] = useAtom(emailAtom);
  const [preferences, setPreferences] = useAtom(preferencesAtom);
  const [completedTasks, setCompletedTasks] = useAtom(completedTasksAtom);
  const [referralCode, setReferralCode] = useAtom(referralCodeAtom);
  const [showIntroFlag, setShowIntroFlag] = useAtom(showIntroFlagAtom);

  return {
    subscriptionTier,
    setSubscriptionTier,
    subscriptionEnd,
    setSubscriptionEnd,
    isDemo,
    setIsDemo,
    email,
    setEmail,
    preferences,
    setPreferences,
    completedTasks,
    setCompletedTasks,
    referralCode,
    setReferralCode,
    showIntroFlag,
    setShowIntroFlag,
  };
};
